import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

interface Payload {
  videoId: string;
}

const validateMedia = async (payload: Payload): Promise<any> => {
  const res = await axiosInstance.post('/api/remotion/validateMedia', payload);
  return res.data;
};

export const useValidateMedia = () => {
  return useMutation(validateMedia, { onSuccess: (data) => data });
};
